import Body from "./Componants/Body/Body";
import Footer from "./Componants/Footer/Footer";
import Header from "./Componants/Header/Header";


function App() {
  return (
    <div>
      <Header />
      <Body />
      <Footer/>
    </div>
  );
}

export default App;
